import TopHeaderContainer from './TopHeaderContainer';

export default TopHeaderContainer;